import { arkScope } from '@/api/workspace/endpoints/arkConfig.ts';
import type { FxCashSpot } from '@/store/cash/state.ts';

export const SavedCashSpotValidator = arkScope.type({
  type: '"FxSpot"',
  properties: {
    'currencyPair?': 'string',
    'notional?': 'number',
    notionalCurrencyIndex: arkScope.type('CurrencyChoice').default(1),
  },
  tileId: 'string',
  'clientId?': 'number',
});

export type SavedCashSpot = typeof SavedCashSpotValidator.infer;

export const SavedCashSpot = {
  fromFxCashSpot: (x: FxCashSpot, tileId: string): SavedCashSpot => ({
    type: 'FxSpot',
    properties: {
      currencyPair: x.properties.currencyPair,
      notional: x.properties.notional,
      notionalCurrencyIndex: x.properties.notionalCurrencyIndex ?? 1,
    },
    tileId,
    clientId: x.clientId,
  }),
} as const;
